// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3NZc1","label":"Completed_label__15juw"};